<template>
<div v-show="isModalVisible">
    <div class="modal-mask" @click="closeModal">
        <div class="modal-container" @click.stop>
            <!-- Modal Header -->
            <div class="row mb-4">
                <div class="col-12">
                    <div class="modal-title">Activate User</div>
                </div>
                <div class="close-icon">
                    <button type="button" class="close" data-dismiss="modal" @click="closeModal">&times;</button>
                </div>
            </div>
            <!-- Modal body -->
            <div class="modal-body">
                <div class="row">
                    <div class="col-12">
                        <div class="font-weight-bold text-center">Are you sure you want to activate </div>
                        <div class="username">
                            {{ capitalizeFirstLetter(userInfo.first_name) + ' ' + capitalizeFirstLetter(userInfo.last_name) }}?
                        </div>
                    </div>
                </div>
                <br/>
                <div class="row m-4">
                    <div class="col-6">
                        <button type="button" class="float-left btn btn-sm cancelBtn" @click="closeModal">Cancel</button>
                    </div>
                    <div class="col-6">
                        <button type="button" class="float-right btn btn-sm sendLinkBtn" @click="activateUser">Activate</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import VeeValidate from 'vee-validate';
import axios from 'axios';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
  props: [
    'isModalVisible',
    'page_from',
    ],
  data() {
    return {
        loading: false,
        userInfo: {},
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    setUserInfo(user) { 
        this.userInfo = user;
    },
    capitalizeFirstLetter(string) {
        if (string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    },
    activateUser() {
        axios.post('/enterpriseadmin/user-status-edit', {
          reasons: ['Employee was re-hired'],
          other_reasons: '',
          type: 'Activate',
          user_id: this.userInfo.id,
          account_id: this.userInfo.accountId,
        })
        .then(response =>  {
            if (this.page_from == 'user_detail') {
                alert('User status updated Successfully');
                this.$parent.close();
            } else if(this.page_from == 'users_menu') {
              this.$parent.userStatusUpdatedMsg = this.userInfo.first_name + ' ' + this.userInfo.last_name + " activated successfully";
              this.$parent.fetchIUsersListitems();  
            } else {
              this.$parent.goToUsersTab();
            }
            this.closeModal();
       })
       .catch((error) => {
          console.log(error)
       });
    },
  },
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  transition: opacity .3s ease;
  overflow-y: scroll;
}
.modal-container {
  position: fixed;
  left: 50%;
  top: 50%;
  -ms-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 500px;
  height: auto;
  overflow-y: auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
 }
.modal-body {
  margin: 0px;
  padding: 10px;
}
.modal-header .close {
  margin: -1.5rem -2rem -1rem auto;
}
.history-table-wrapper {
  height: 350px;
  overflow-y: auto;
}
.modal-footer {
  border-top: none;
}
.btn-danger {
  background-color: #00ACEE;
  border-color: #00ACEE;
}
.modal-title {
  color: #00acee;
  font-size: 1.4rem;
  font-weight: 900;
  text-align: center !important;
}
.modal-header {
  padding: 5px;
  border-bottom: 0px;
  margin-bottom: 10px;
  text-align: center !important;
}
.modal-body {
  padding: 5px;
}
@media (min-width: 320px) and (max-width: 991px) { 
  .modal-container {
    width: 100%;
  }
}
.cancelBtn, .cancelBtn:focus, .cancelBtn:active, .cancelBtn:hover {
  color: #00acee !important; 
  background-color: #FFF !important;
  border: 1px solid #00acee !important;
  font-weight: 900;
  width: 150px;
  border-radius: 10px;
}
.sendLinkBtn, .sendLinkBtn:focus, .sendLinkBtn:active, .sendLinkBtn:hover {
  color: #FFF !important;
  background: #00ACEE !important;
  border: 1px solid #00ACEE !important;
  min-height: 35px;
  margin-top: -5px;
  border-radius: 10px;
  width: 150px;
}
.username { font-size: 1.05rem; font-weight: 900; text-align: center; margin: 10px 0; }
.close-icon { position: absolute; left: 0; right: 15px; top: 10px }
</style>


// WEBPACK FOOTER //
// src/components/enterpriseadmin/user_activate_modal.vue